import React, { memo, useMemo } from "react";
import { Box, Button, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { BOTON_PRIMARIO_SX } from "../../../../components/ui/buttonStyles";
import { MOSTRADORES } from "../../../../config/constants";
import { opcionesEmpleado } from "../../helpers/entradas";

const MOTIVO_SIN_RUTA = "Configura una ruta de mostrador para poder llamar al siguiente";
const MOTIVO_SIN_EMPLEADO = "Selecciona un empleado";

const SELECT_SX = { minWidth: { xs: "100%", md: 180 }, fontSize: 14 };
const CAMPO_SX = { flex: { xs: "1 1 auto", md: "0 0 auto" } };

// Selector con la etiqueta en un Typography encima (sin InputLabel flotante)
const CampoSelect = ({ id, etiqueta, value, onChange, children, ...resto }) => (
    <Box sx={CAMPO_SX}>
        <Typography component="label" htmlFor={id} variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: "#495057", display: "block" }}>
            {etiqueta}
        </Typography>
        <Select
            id={id}
            size="small"
            fullWidth
            value={value}
            onChange={(e) => onChange(e.target.value)}
            sx={SELECT_SX}
            inputProps={{ "aria-label": etiqueta }}
            {...resto}
        >
            {children}
        </Select>
    </Box>
);

/**
 * Barra de acciones del gestor: "Llamar al siguiente" y los selectores de
 * empleado y mostrador. Presentacional: recibe el estado y los callbacks.
 * `bloqueado` cubre la carga de la cola y las acciones en vuelo.
 */
const ToolbarGestor = ({
    hayRuta,
    bloqueado = false,
    empleados,
    empleadoId,
    mostrador,
    onLlamarSiguiente,
    onEmpleadoChange,
    onMostradorChange,
}) => {
    const opciones = useMemo(() => opcionesEmpleado(empleados), [empleados]);
    const motivo = !hayRuta ? MOTIVO_SIN_RUTA : !empleadoId ? MOTIVO_SIN_EMPLEADO : "";

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "flex-end" },
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            <Tooltip title={motivo}>
                <span>
                    <Button
                        variant="contained"
                        fullWidth
                        startIcon={<CampaignIcon />}
                        onClick={onLlamarSiguiente}
                        disabled={Boolean(motivo) || bloqueado}
                        sx={BOTON_PRIMARIO_SX}
                    >
                        Llamar al siguiente
                    </Button>
                </span>
            </Tooltip>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>
                <CampoSelect id="empleado-select" etiqueta="Empleado" value={empleadoId} onChange={onEmpleadoChange} displayEmpty>
                    <MenuItem value="">— Selecciona —</MenuItem>
                    {opciones.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                            {o.label}
                        </MenuItem>
                    ))}
                </CampoSelect>
                <CampoSelect id="mostrador-select" etiqueta="Mostrador" value={mostrador} onChange={onMostradorChange}>
                    {MOSTRADORES.map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                            {m.label}
                        </MenuItem>
                    ))}
                </CampoSelect>
            </Box>
        </Box>
    );
};

export default memo(ToolbarGestor);
